/* eslint-disable react-hooks/exhaustive-deps */
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useGlobalSearch } from "@/global-data";
import { HIDE_LIST_FILTER } from "@/global-data/global-const";
import { LoaderCircleIcon, SearchIcon, XIcon } from "lucide-react";
import { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigation, useSearchParams } from "react-router-dom";

export const DashboardSearch = () => {
  const { search, setSearchText, progress } = useGlobalSearch();
  const navigation = useNavigation();

  useEffect(() => {
    if (navigation.state === "loading") {
      console.log("🔁 Navigation started");
    }
  }, [navigation.state]);

  const location = useLocation();
  const [searchParam] = useSearchParams();
  const { pathname } = location;
  const parent = searchParam.get("parent");

  const key = parent ? `search-${pathname}-parent` : `search-${pathname}`;

  const persist_urls = ["/document", "/classification"];
  const [searchParams, setSearchParams] = useSearchParams();
  const filterParam = searchParams.get("filter");

  useEffect(() => {
    if (persist_urls.includes(pathname)) {
      if (filterParam) {
        const customFilter = JSON.parse(filterParam);
        console.log(customFilter.state[0]);
        if (customFilter?.state?.[0]) {
          console.log(customFilter?.state?.[0]);
          setSearchText(customFilter?.state?.[0] || "");
          setTempSearch(customFilter?.state?.[0] || "");
          setTimeout(() => {
            setSearchText(customFilter?.state?.[0] || "");
            setTempSearch(customFilter?.state?.[0] || "");
            setSearchParams("");
          }, 1000);
        }
      }
    }
  }, [filterParam]);

  useEffect(() => {
    if (persist_urls.includes(pathname)) {
      sessionStorage.setItem(key, search);
    }
  }, [search]);
  useEffect(() => {
    if (persist_urls.includes(pathname)) {
      const searchText = sessionStorage.getItem(key);
      setSearchText(searchText || "");
      setTempSearch(searchText || "");
    } else {
      setSearchText("");
      setTempSearch("");
    }
  }, [pathname]);

  const isDetails = useMemo(() => {
    const allBreadcrumb = pathname.split("/");
    return allBreadcrumb.find((item) => item === "details") ? true : false;
  }, [pathname]);

  const [tempSearch, setTempSearch] = useState(search);
  const clearSearch = () => {
    setTempSearch("");
    setSearchText("");
  };

  return (
    <>
      {HIDE_LIST_FILTER.includes(pathname) || isDetails ? null : (
        <div className="relative md:block hidden w-full">
          <Input
            className="bg-white h-auto pr-10 w-full"
            type={"text"}
            onChange={(e) => setTempSearch(e.target.value)}
            value={tempSearch}
            // onChange={(e) => setSearchText(e.target.value)}
            // value={search}
            placeholder="Search here"
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                setSearchText(tempSearch);
              }
            }}
            onKeyUp={(e) => {
              if (e.key === "Escape") {
                clearSearch();
              } else if (e.currentTarget.value === "") {
                setSearchText(tempSearch);
              }
            }}
          />
          {progress ? (
            <LoaderCircleIcon
              size={16}
              className="absolute right-[35px] animate-spin text-primary top-0 bottom-0 m-auto"
            />
          ) : tempSearch === "" ? (
            ""
          ) : (
            <Button
              className="absolute right-[35px] top-0 p-1 h-[30px] w-[30px]  bottom-0 m-auto"
              variant={"ghost"}
              onClick={clearSearch}
            >
              <XIcon className="  text-red-500 " />
            </Button>
          )}
          <Button
            className="absolute right-[5px] top-0 bottom-0 m-auto p-1 h-[30px] w-[30px] ml-[2px] "
            variant={"ghost"}
            onClick={() => setSearchText(tempSearch)}
            disabled={progress}
          >
            <SearchIcon size={16} className="" />
          </Button>
        </div>
      )}
    </>
  );
};
